module.exports = __webpack_public_path__ + "img/MS.f491a76c.png";